import classNames from "classnames";
import PropTypes from "prop-types";
import style from "./account.module.scss";
import { useNavigate } from "react-router-dom";

const AccountHeader = ({ headername, onBackPress }) => {
  const headerClass = classNames(style.accountHeader, headername);
  const iconClass = classNames("tg-icons-RightArrow", style.rightArrowIcon);
  const titleClass = classNames(style.headerTitle);
  const navigate = useNavigate();

  const handleBackClick = () => {
    onBackPress ? onBackPress() : navigate(-1);
  };

  return (
    <div className={headerClass}>
      <button className={style.button} onClick={handleBackClick}>
        <i className={iconClass} />
      </button>
      <span className={titleClass}>{headername}</span>
      <div className={style.spacer}></div>
    </div>
  );
};

AccountHeader.propTypes = {
  headername: PropTypes.string.isRequired,
  onBackPress: PropTypes.func,
};

export default AccountHeader;
